import { Suspense, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconFileVisualizationOutline } from '@iwoca/icons';
import { Modal } from '@iwoca/orion';
import { Button, Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { useGetTopupPendingBannerData } from './useGetTopupPendingBannerData';
import HelpModal from '../../../navigation/helpModal/HelpModal';
import MainContentPending from '../../../pageStructure/mainContentPending';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals';

export const TopupPendingBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <>
            <div className="col-span-5 grid grid-cols-7 gap-m rounded-s border border-secondary-90 bg-primary-97 p-l max-sm:col-span-full">
                <div className="col-span-1 m-auto max-sm:col-span-full">
                    <IconFileVisualizationOutline
                        fontSize={48}
                        className="text-secondary-40"
                    />
                </div>
                <Suspense fallback={<MainContentPending />}>
                    <BannerContent />
                </Suspense>
                <div className="col-span-full max-sm:col-span-full max-sm:text-center min-m:col-start-2">
                    <Button
                        onClick={() => {
                            tracking.ampli.topupChangeRequestCtaClicked();
                            setIsModalOpen(true);
                        }}
                    >
                        <FormattedMessage
                            id="_.rbl_dashboard.outstanding.changeTopupRequest"
                            defaultMessage="Change request"
                        />
                    </Button>
                </div>
            </div>

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <HelpModal />
            </Modal>
        </>
    );
};

const BannerContent = () => {
    const { topUpAmount, isRepaymentReductionApplication } =
        useGetTopupPendingBannerData();
    return (
        <div className="col-span-6 max-sm:col-span-full max-sm:text-center">
            <Text className="text-xl font-bold">
                {isRepaymentReductionApplication ? (
                    <FormattedMessage
                        id="_.dashboard.outstanding.repayment_reduction_pending_title"
                        defaultMessage="Repayment reduction application complete"
                    />
                ) : (
                    <FormattedMessage
                        id="_.rbl_dashboard.outstanding.topupPendingTitle"
                        defaultMessage="Top up requested"
                    />
                )}
            </Text>
            <Text className="text-l">
                {isRepaymentReductionApplication ? (
                    <FormattedMessage
                        id="_.dashboard.outstanding.repayment_reduction_pending_description"
                        defaultMessage="Thanks for your application to reduce your monthly repayments."
                    />
                ) : (
                    <FormattedMessage
                        id="_.rbl_dashboard.outstanding.topupPendingDescription"
                        defaultMessage="Thanks for your application for a top up to a credit limit of {amount}"
                        values={{
                            amount: <MoneyWithDecimals value={topUpAmount!} />
                        }}
                    />
                )}
            </Text>
        </div>
    );
};
